import React from 'react';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useRagnar } from '@mentimeter/ragnar-react';

interface TitleVoteCounterProps {
  numberOfResponses: number;
  numberOfResponsesWithUpvotes: number;
  shouldShowVotes: boolean;
}

export const TitleVoteCounter = ({
  numberOfResponses,
  numberOfResponsesWithUpvotes,
  shouldShowVotes,
}: TitleVoteCounterProps) => {
  const { useTranslate } = usePresentationContext();
  const translate = useTranslate();
  const {
    theme: {
      visualizationColors: { titleColor },
    },
  } = useRagnar();

  const headingText = (() => {
    if (shouldShowVotes) {
      return numberOfResponsesWithUpvotes === 1
        ? translate('open.response_with_votes')
        : translate('open.responses_with_votes', {
            numberOfResponses: numberOfResponsesWithUpvotes,
          });
    }

    const responseWord =
      numberOfResponses === 1
        ? translate('message.response')
        : translate('message.responses');
    return `${numberOfResponses} ${responseWord}`;
  })();

  return (
    <Text
      color={titleColor}
      as="h2"
      data-testid="response-indicator"
      fontSize="200"
      mt="space1"
      lineHeight="none"
    >
      {headingText}
    </Text>
  );
};
